"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./styles.scss");
var _texts = require("../texts");
var _util = require("../../../util");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BLOCK_CLASS = 'pf-table';
var bem = (0, _util.klass)(BLOCK_CLASS);
var Table = function Table(_ref) {
  var rows = _ref.rows,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("dl", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  }, rows.map(function (row) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: row.header
    }, /*#__PURE__*/_react.default.createElement(_texts.Text, {
      "data-test-id": row.id,
      as: "dt",
      className: bem('header')
    }, row.header), /*#__PURE__*/_react.default.createElement(_texts.Text, {
      as: "dd",
      className: bem('text', row.subText && 'text--has-sub-text')
    }, row.text, /*#__PURE__*/_react.default.createElement(_texts.Text, {
      className: bem('sub-text')
    }, row.subText)));
  }));
};
Table.propTypes = {
  rows: _propTypes.default.arrayOf(_propTypes.default.shape({
    header: _propTypes.default.string,
    text: _propTypes.default.string,
    subText: _propTypes.default.string
  })).isRequired,
  className: _propTypes.default.string
};
Table.defaultProps = {
  className: ''
};
var _default = Table;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');